module.exports = __webpack_public_path__ + "img/top-cleaning.f8b5a3f.jpg";